import { render, staticRenderFns } from "./MovableWrapper.vue?vue&type=template&id=13730ea6&scoped=true&"
import script from "./MovableWrapper.vue?vue&type=script&lang=js&"
export * from "./MovableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MovableWrapper.vue?vue&type=style&index=0&id=13730ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13730ea6",
  null
  
)

export default component.exports